import React from "react";
import { NavBarLogo } from "./NavBarLogo";
import { NavBarUserMenu } from "./NavBarUserMenu";
import { BusinessPageSection } from "./components/BusinessPageSection";
import { TimeFrameSection } from "./components/TimeFrameSection";
import { TimeFrameOption } from "@/components/business/leads/utils/dateFilters";
import { Business } from "@/schemas/business"; // Changed to Zod-inferred type
import { FEATURE_FLAGS } from "@/config/featureFlag";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";

interface NavBarMainRowProps {
  businessName?: string
  timeFrame?: TimeFrameOption | string
  onTimeFrameChange?: (value: TimeFrameOption) => void
  allBusinesses: Business[]
  effectiveBusinesses: Business[]
  handleNavigation: (id: string) => void
  isBusinessPage: boolean
  isBusinessSettingsPage: boolean
  navigate: any
  isMobile: boolean
  portfolioDropdown?: boolean
  selectedPortfolio?: string
  portfolioOptions?: Array<{
    id: string
    title?: string
    name?: string
    role?: string | null
  }>
  onPortfolioChange?: (value: string) => void
  isGoCampaignPage?: boolean
  isEditPage?: boolean
  handleEditCampaign?: () => void
  handleEditGoPlan?: () => void
  handleEditGoCampaign?: () => void
  handleNavigateToSettings?: () => void
}

export const NavBarMainRow: React.FC<NavBarMainRowProps> = ({
  businessName,
  timeFrame,
  onTimeFrameChange,
  allBusinesses,
  effectiveBusinesses,
  handleNavigation,
  isBusinessPage,
  isBusinessSettingsPage,
  navigate,
  isMobile,
  isGoCampaignPage = false,
  isEditPage = false,
  handleEditCampaign,
  handleEditGoPlan,
  handleEditGoCampaign,
  handleNavigateToSettings,
}) => {
  return (
    <div className="flex items-center justify-between py-2 w-full max-w-screen-xl mx-auto px-4 md:px-8">
      <div className="flex items-center gap-3 flex-1">
        <NavBarLogo navigate={navigate} />

        {isBusinessPage && !isMobile && (
          <BusinessPageSection
            businessName={businessName}
            allBusinesses={effectiveBusinesses}
            handleNavigation={handleNavigation}
            isGoCampaignPage={isGoCampaignPage}
            isEditPage={isEditPage}
            handleEditGoPlan={handleEditGoPlan}
            handleEditGoCampaign={handleEditGoCampaign}
          />
        )}

        {!isBusinessSettingsPage &&
          !isEditPage &&
          !isGoCampaignPage &&
          isBusinessPage &&
          !isMobile && (
            <TimeFrameSection
              timeFrame={timeFrame}
              onTimeFrameChange={onTimeFrameChange}
            />
          )}
      </div>

      <div className="flex items-center gap-2">
        {/* Hamburger menu removed as requested */}

        {/* Edit GoCampaign button visible on business pages */}
        {isBusinessPage && !isGoCampaignPage && FEATURE_FLAGS.ONBOARDING && (
          <Button
            variant="ghost"
            size="icon"
            onClick={(e) => {
              e.preventDefault();
              if (handleEditGoCampaign) {
                handleEditGoCampaign();
              }
            }}
            className="text-gray-600 hover:text-gray-900"
          >
            <Pencil className="w-5 h-5" />
            <span className="sr-only">Edit GoCampaign</span>
          </Button>
        )}

        <NavBarUserMenu />
      </div>
    </div>
  )
}
